import React, { useEffect, useState } from "react";
import { graphql, useStaticQuery, Link } from "gatsby";

import clsx from "clsx";
import PubSub from "pubsub-js";
import SanityImage from "./SanityImage";
import Cart from "./shop/Cart";
// import Pre from "./ui/Pre";

const query = graphql`
  query {
    allSanityCategory(filter: { title: { ne: null } }) {
      nodes {
        title
        slug {
          current
        }
      }
    }
    allSanityProduct(filter: { category: { title: { ne: null } } }) {
      nodes {
        ...product
      }
    }
  }
`;
const SousMenuShop = ({ input, j }) => (
  <li
    key={`key-${input.slug.current}`}
    className='flex-shrink-0'
    style={{
      transitionDelay: `${j * 0.2}ms`,
    }}>
    <Link to={`/product/${input.slug.current}`}>
      <div className='pen'>
        <SanityImage input={{ image: input.images[0] }} maxHeight={80} />
      </div>
    </Link>
  </li>
);

const MenuShop = () => {
  const { allSanityCategory, allSanityProduct } = useStaticQuery(query);

  const [active, setActive] = useState();

  useEffect(() => {
    const token = PubSub.subscribe("MENU_SHOP_ACTIVE", (e, d) => {
      setActive(d);
    });

    return () => PubSub.unsubscribe(token);
  }, []);

  const _canPurchase = (product) => {
    let _can = true;
    // console.log(product.title);
    const isDrop = product.productDrop && product.productDrop.dropDate;
    if (isDrop) {
      _can = product.productDrop.seconds >= 0;
      console.log(product.productDrop.seconds);
    }
    return _can;
  };

  const _getProductsByCat = (cat) => {
    // return allSanityProduct.nodes.filter((el) => {
    //   return el.category && el.category.title === cat && _canPurchase(el);
    // });
    // console.log(allSanityProductWithoutDrop.length);
    return allSanityProductWithoutDrop.filter((el) => {
      // console.log(_canPurchase(el));
      return el.category && el.category.title === cat;
    });
  };

  const allSanityProductWithoutDrop = allSanityProduct.nodes.filter((el) =>
    _canPurchase(el)
  );

  // console.log(allSanityProduct.nodes.length);
  // console.log(allSanityProductWithoutDrop.length);
  // const sanitizedMenu = allSanityCategory.nodes.filter(
  //   el => el.slug && el.slug.current !== null
  // );
  // const sanitizedProducts = allSanityProduct.nodes.filter(
  //   el => el.category && el.category.title !== null
  // );

  return (
    <nav className={clsx("menu-shop hidden-sm", active ? "is-active" : "")}>
      <div className={clsx("inner  px-md---")}>
        <div className='flex justify-between'>
          <ul className='flex flex-col md:flex-row flex-nowrap menu'>
            <li className='menu-item text-sm-lg md:text-base'>
              <Link to={`/shop`}>All</Link>
              <ul
                className={clsx(
                  "products flex flex-wrap absolute md:col-6-13"
                )}>
                {allSanityProductWithoutDrop.map((el, j) => (
                  <SousMenuShop input={el} key={j} j={j} />
                ))}
              </ul>
            </li>
            {allSanityCategory.nodes.map((li, i) => (
              <li
                key={i}
                className={clsx(
                  "menu-item text-sm-lg md:text-base",
                  `menu-item-${i}`
                )}>
                <Link to={`/category/${li.slug.current}`}>{li.title}</Link>
                <ul
                  className={clsx(
                    "products flex flex-wrap absolute md:col-6-13"
                  )}>
                  {_getProductsByCat(li.title).map((el, j) => (
                    <SousMenuShop input={el} key={j} j={j} />
                  ))}
                </ul>
              </li>
            ))}
          </ul>
          <div className='px-md'>
            <Cart />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MenuShop;
